import { hydrating } from '../hydration.js';
import { clear_text_content, get_first_child } from '../operations.js';
import { queue_micro_task } from '../task.js';

/**
 *
 *
 *
 */
export function autofocus(dom, value) {
	if (value) {
		const body = document.body;
		dom.autofocus = true;

		queue_micro_task(() => {
			if (document.activeElement === body) {
				dom.focus();
			}
		});
	}
}

/**
 *
 *
 *
 *
 */
export function remove_textarea_child(dom) {
	if (hydrating && get_first_child(dom) !== null) {
		clear_text_content(dom);
	}
}

let listening_to_form_reset = false;

export function add_form_reset_listener() {
	if (!listening_to_form_reset) {
		listening_to_form_reset = true;
		document.addEventListener(
			'reset',
			(evt) => {
				/*                                                                    */
				/*                                                  */
				Promise.resolve().then(() => {
					if (!evt.defaultPrevented) {
						for (const e of /*                         */ (evt.target).elements) {
							/*               */
							e.__on_r?.();
						}
					}
				});
			},
			/*                                                                                         */
			{ capture: true }
		);
	}
}
